import baseLogger, { CONTEXTS } from 'widget/logger';
import createAuthHeaders from 'widget/services/utils/createAuthHeaders';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { ArtistStream } from '../types';
import { TransportInterface } from 'widget/utils/transport/types';

/*
 * Fetch artist data given a artist id
 */
export async function fetchArtistStream({
  ampUrl = '',
  artistId,
  logger = baseLogger,
  profileId,
  mfr,
  sessionId,
  streamType = mfr ? 'FAVORITES' : 'ARTIST',
  transport,
}: {
  ampUrl?: string;
  artistId?: number;
  logger?: Logger;
  mfr?: boolean;
  profileId?: string | number;
  sessionId?: string;
  streamType?: 'FAVORITES' | 'ARTIST';
  transport: TransportInterface;
}): Promise<ArtistStream> {
  if (!artistId && !profileId) {
    const errObj = new HttpError(
      400,
      'Failed to fetch stream info, artist id and profile id missing.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  const [url, requestName] = createTaggedUrl`${{ ampUrl }}/api/v2/playlists/${{
    profileId: profileId || '',
  }}/${{ streamType }}/${{ stationId: artistId || String(profileId!) }}`;

  let data;
  try {
    ({ data } = await transport.post(
      url,
      {
        contentId: artistId,
        playedFrom: 157,
      },
      {
        headers: createAuthHeaders({
          profileId: String(profileId) || '',
          sessionId: sessionId || '',
        }),
        params: { requestName },
      },
    ));

    if (!data) {
      const errObj = new HttpError(
        400,
        'Failed to fetch artist station info, no results.',
      );
      logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
      throw errObj;
    }
  } catch (error: any) {
    const { response } = error;
    const errObj = new Error(`Failed to fetch station info, ${response}`);
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
  }

  return data;
}
